module.exports = __webpack_public_path__ + "img/IMG_7228.26ba6702.webp";